import { render, staticRenderFns } from "./Caca.vue?vue&type=template&id=40fd5766&scoped=true"
import script from "./Caca.vue?vue&type=script&lang=js"
export * from "./Caca.vue?vue&type=script&lang=js"
import style0 from "./Caca.vue?vue&type=style&index=0&id=40fd5766&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fd5766",
  null
  
)

export default component.exports